import { render, staticRenderFns } from "./VentasComponent.vue?vue&type=template&id=b1b38b1a"
import script from "./VentasComponent.vue?vue&type=script&lang=js"
export * from "./VentasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports